<template>
  <div
    class="absolute top-0 w-full electron-drag"
    :style="{ height: `${height}px` }"
  />
</template>

<script>
export default {
  name: 'ElectronInvisibleHeader',
  props: {
    height: {
      type: Number,
      default: 0,
      required: false,
    },
  },
};
</script>
